// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueScratchCard from 'vue-scratch-card0';
import VueWechatTitle from 'vue-wechat-title';
import router from './router'
import store from './store'
import '@/assets/css/common.css'
Vue.config.productionTip = false
Vue.use(VueWechatTitle)
Vue.use(VueScratchCard)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js